export class OnboardingModel {
    public Items: Array<any> = [];
    public Skip: number = 0;
    public Take: number = 10;
    public TotalRecords: number = 0;
    public Loading: boolean = true;
}
